import { render, staticRenderFns } from "./TerraIcon.vue?vue&type=template&id=4aff5610&"
import script from "./TerraIcon.vue?vue&type=script&lang=js&"
export * from "./TerraIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports